import { FinalPrice, PriceSummary } from '@/models/summary';
import { VAT_FALLBACK } from './constants';
import { ProductType } from '@/models/ad';

const getPrice = ({
  priceSummary,
  productType,
}: {
  priceSummary?: PriceSummary;
  productType: ProductType;
}) => {
  if (!priceSummary) {
    return 0;
  }

  if (productType === ProductType.Image) {
    return priceSummary.image;
  }
  if (productType === ProductType.Video15s) {
    return priceSummary.video15s;
  }
  if (productType === ProductType.Video30s) {
    return priceSummary.video30s;
  }

  return 0;
};

export const calculateFinalPrice = ({
  prices,
  type,
  displays,
  views,
}: FinalPrice) => {
  let count = 0;
  if (displays) {
    count = displays / 1000;
  } else if (views) {
    count = views / 1000;
  }
  const mediaPrice = getPrice({
    priceSummary: prices,
    productType: type,
  });
  const net = count * mediaPrice;
  const vat = net * (prices?.vat ? prices.vat : VAT_FALLBACK);

  let gross = parseFloat((net + vat).toFixed(2));

  return gross.toString();
};

export const calculateAmountBasedOnBudget = ({
  budget,
  prices,
  type,
}: {
  budget: number | string;
  prices?: PriceSummary;
  type: ProductType;
}) => {
  const mediaPrice = getPrice({
    priceSummary: prices,
    productType: type,
  });
  const net =
    parseFloat(`${budget}`) -
    parseFloat(`${budget}`) * (prices?.vat ? prices.vat : VAT_FALLBACK);

  return (net / mediaPrice) * 1000;
};

export const calculateNet = ({ prices, type, displays, views }: FinalPrice) => {
  let count = 0;
  if (displays) {
    count = displays / 1000;
  } else if (views) {
    count = views / 1000;
  }
  const mediaPrice = getPrice({
    priceSummary: prices,
    productType: type,
  });
  const net = count * mediaPrice;

  return net.toString();
};
